import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function ChannelBasicInfoComponent ({channels,handleInnerFormChange, selectedChannel}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedChannel?.Name}
          />
        
        <InputContainer
         label="Channel Name"
                  labelField="Name"
                  list={channels}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'ChannelId',
      
                      )
                  }}
                  optionName="Choose Channel name"
                  type="select"
                  value={selectedChannel?.ChannelId}
                  valueField="Id"
              />

              <InputContainer

                label="Code"
                name="Code"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'Code',

                    )
                }}
                type="text"
                value={selectedChannel?.Code}
                />
                <InputContainer

                    label="Display Order"
                    name="DisplayOrder"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'DisplayOrder',
    
                        )
                    }}
                    type="number"
                    value={selectedChannel?.DisplayOrder}
                    />
                    <InputContainer

                        label="Label"
                        name="Label"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Label',
        
                            )
                        }}
                        type="text"
                        value={selectedChannel?.Label}
                        />
                        <InputContainer

                            label="Active"
                            name="IsActive"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsActive',
            
                                )
                            }}
                            type="checkbox"
                            value={selectedChannel?.IsActive}
                            />
                            <InputContainer

                                label="Deleted"
                                name="IsDeleted"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'IsDeleted',
                
                                    )
                                }}
                                type="checkbox"
                                value={selectedChannel?.IsDeleted}
                                />
                                   <div className='col-span-full'>
                                <InputContainer

                                label="Short Description"

                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                    'ShortDescription'
                                    );
                                }}
                                  type="rte"
                                value={selectedChannel?.ShortDescription}
                                /></div>
                                   <div className='col-span-full'>
                                 <InputContainer

                                    label="Long Description"

                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                        'LongDescription'
                                        );
                                    }}
                                        type="rte"
                                    value={selectedChannel?.LongDescription}
                                    /></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}